import React from "react";
import { compose } from "recompose";
import { Table } from "reactstrap";
import {
  TableContainer,
  TableDataFetch,
  AddNewButton,
  withTable,
  BulkDeleteButton,
  EditDeleteButtons,
  ViewingRecords,
} from "components/common/Tables/index";
import Page from "components/common/Page";
import { Trans } from "react-i18next";
import { formatDateTime } from "services/util";
import { NotificationManager } from "react-notifications";

export const HesaabEmployeeList = ({
  selected,
  match,
  url = "core/employees",
  setSelected,
  ordering,
  setOrdering,
  data,
  setData,
  limit,
  offset,
  setOffset,
  search,
  setSearch,
  isDeleteModalOpen,
  toggleDeleteModal,
  onDeleteItem,
  onDeleted,
  refreshToken,
  readOnly,
}) => (
  <Page title="Employees" className="inv-table">
    <BulkDeleteButton
      className="float-right mb-2"
      toggleModal={toggleDeleteModal}
      selected={selected}
      url={url}
      onDeleted={onDeleted}
      isModalOpen={isDeleteModalOpen}
      readOnly={readOnly}
    />
    <AddNewButton
      resource="Employee"
      match={match}
      className="float-left mb-2"
      readOnly={readOnly}
    />
    <TableContainer
      items={data.results}
      ordering={ordering}
      onOrderingChanged={setOrdering}
      selected={selected}
      onSelectedChanged={setSelected}
    >
      <Table>
        <thead>
          <tr>
            <th select style={{ width: 1 }} />
            <th sortBy="first_name">
              <Trans>First name</Trans>
            </th>
            <th sortBy="contact_number">
              <Trans>Contact number</Trans>
            </th>
            <th sortBy="department">
              <Trans>Department</Trans>
            </th>
            <th>
              <Trans>Referral link</Trans>
            </th>
            <th sortBy="reference_count">
              <Trans># of clients</Trans>
            </th>
            <th sortBy="created_at">
              <Trans>Created at</Trans>
            </th>
            <th sortBy="active">
              <Trans>Status</Trans>
            </th>
            <th />
          </tr>
        </thead>
        <tbody>
          {data.results.map((i) => (
            <tr key={i.id}>
              <td select />
              <td>{i.first_name}</td>
              <td>{i.contact_number}</td>
              <td>{i.department}</td>
              <td>
                {i.referral_code ? <span>
                  <a href={i.referral_link} target="_blank">{i.referral_code}</a>
                  <i className="far fa-copy ml-2" style={{ fontSize: 20, }} onClick={() => { navigator.clipboard.writeText(i.referral_link); NotificationManager.success('Referral link copied!'); }}></i>
                </span> : '-'}
                
              </td>
              <td>{i.reference_count}</td>
              <td>{formatDateTime(i.created_at)}</td>
              <td>
              {i.active ? (
                    <span className="fa fa-check-circle text-success" />
                  ) : (
                    <span className="fa fa-times-circle text-danger" />
                  )}
              </td>
              <td className="text-end edit-btn">
                <EditDeleteButtons
                  url={match.url}
                  id={i.id}
                  onDelete={onDeleteItem}
                  readOnly={readOnly}
                />
              </td>
             
            </tr>
          ))}
        </tbody>
      </Table>
    </TableContainer>
    <TableDataFetch
      ordering={ordering}
      refreshToken={refreshToken}
      search={search}
      limit={limit}
      url={url}
      offset={offset}
      onDataFetched={setData}
    />
    <ViewingRecords
      offset={offset}
      limit={limit}
      count={data.count}
      className="float-left"
    />
  </Page>
);

const enhance = compose(withTable({ limit: 999999 }));

export default enhance(HesaabEmployeeList);
